import React from 'react';
import {MessageAlert} from '@techsee/techsee-ui-common/lib/message-alert';

export enum ToastColors {
    Info = '#0056D8',
    Secondary = '#706E6B',
    Muted = '#686868E5',
    Danger = '#FF0000',
    Warning = 'rgba(239,79,0,1)',
    DangerAlt = 'rgba(255,0,0,1)',
    Success = '#00CF49'
}

export type TsToastProps = {
    message?: string;
    timeout?: number; // in ms; default 2500; if 0 → no timeout
    type: ToastColors;
    className?: string;
    onMessageClosed?: () => void;
};

export const TsToast: React.FC<TsToastProps> = ({message, timeout, type, className, onMessageClosed}) => {
    if (!message) {
        return null;
    }

    const effectiveTimeout = timeout === undefined ? 2500 : timeout;
    const autoCloseProps = effectiveTimeout === 0 ? {} : {autoCloseTimeout: effectiveTimeout};

    return (
        <MessageAlert
            label={message}
            color={type}
            className={className}
            style={{height: 'auto'}}
            onMessageClosed={onMessageClosed}
            {...autoCloseProps}
        />
    );
};
